<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:14:31
 * @LastEditTime: 2019-08-16 14:35:35
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
      <el-form-item label="产品名称:">
        <el-input v-model="form1.product_sn" clearable readonly></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="dialogVisible=!dialogVisible">选择</el-button>
      </el-form-item>
      <el-form-item label="经销商:">
        <el-input v-model="form1.to_sn" clearable readonly></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="selectType()">选择</el-button>
      </el-form-item>
      <el-form-item style="margin-left:50px;">
        <el-button type="primary" @click="getData()">搜索</el-button>
        <el-button @click="onExport()">导出</el-button>
      </el-form-item>
    </el-form>
     <div style='position: relative;'>
                  <div class="countType">
                <el-button size="mini" @click="countFun('1')" :class="{'active':home_type=='1'}">月</el-button>
                <el-button size="mini" @click="countFun('2')" :class="{'active':home_type=='2'}">季</el-button>
                <el-button size="mini" @click="countFun('3')" :class="{'active':home_type=='3'}">年</el-button>
            </div>
        </div>
    <div id="charts" ref="myEchart"></div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%;margin: 20px"
    >
      <el-table-column prop='name' label="时间" fixed></el-table-column>
      <el-table-column prop='start_stock' label="期初库存" show-overflow-tooltip></el-table-column>
      <el-table-column prop='end_stock' label="期末库存" show-overflow-tooltip></el-table-column>
      <el-table-column prop='average_stock' label="平均库存" show-overflow-tooltip></el-table-column>
      <el-table-column prop='out_stock' label="出货总数" show-overflow-tooltip></el-table-column>
      <el-table-column prop='turnover_percent' label="产品周转率" show-overflow-tooltip></el-table-column>
    </el-table>
    <!-- <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange2"
      @current-change="handleCurrentChange2"
      :current-page="pageNo2"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize2"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize2"
    ></el-pagination> -->
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
    <selectProducts
      v-if="dialogVisible"
      v-on:handleClose="dialogVisible = false"
      v-on:pushData="getChildData"
    ></selectProducts>
  </div>
</template>


<script>
import selectDealer from "@/common/selectDealer";

import { option } from "@/assets/js/option/turnOpthion.js";
import selectProducts from "@/common/selectProducts";

export default {
  data() {
    return {
      dialogVisible: false,
      selectDealerDialog: false,
      tableData:[],
        charts: '',
      loading:false,

      form1: {
        product_sn: "",
        to_sn: ""
      },home_type:'1'
    };
  },
  mounted() {
        this.$nextTick(function() {
    this.chartsConfigure();
            })
  },
  methods: {
     // 获取产品列表
            getProduct(){
 
                this.$get('logistics','/products').then(res => {
                    this.loading = false;
                    this.form1.product_sn=res.data[0].product_sn
                    this.getData()
                }).catch(function (error) {
                    this.loading = false;
               
                });
            },
    //选择经销商
    selectType() {
      this.selectDealerDialog = true;
    },
    getSelectinfo(val) {
            this.form1.to_sn = val.dealer_sn;
    },
    chartsConfigure() {
      let myChart = this.$echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置
      window.onresize = myChart.resize;
      myChart.setOption(option);
    },
    onExport(){
      let access_tokens = localStorage.getItem('access_token')
       window.open(process.env.VUE_APP_URL+'/turnovers.export?is_export=1&to_sn=' + this.form1.to_sn +'&product_sn=' + this.form1.product_sn +'&turnover_type='+this.home_type+'&lang=' + ''+'&signature='+ this.$md5(access_tokens))
    },
    getChildData(val) {
      this.form1.product_sn=val.product_name
    },
      //echart
            drawLine(id){
                this.charts = echarts.init(document.getElementById(id))
                this.charts.setOption(option)
            },
    getData(){
         if(this.product_sn==''){
                     this.$message({
                        type: 'error',
                        message: "请选择产品"
                    });
                    return;
                }
                this.$get('logistics','/turnovers', {
                    lang:'',
                 
                    turnover_type:this.home_type,
                    ...this.form1
                }).then(res => {
                    this.tableData=res.data
                    for (var i = 0; i < res.data.length; i++) {
                        option.xAxis.data.push(res.data[i].name);
                        option.series[0].data.push(res.data[i].turnover_percent);
                    }
                         let myChart = this.$echarts.init(this.$refs.myEchart);
                          myChart.setOption(option);
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
              
                });
    }
  },
  created(){
    this.getProduct()
  },
  components: {
    selectDealer,
    selectProducts
  }
};
</script>


<style lang="scss" scoped>
#charts {
  height: 400px;
}
    .active{
        background-color: rgb(230, 243, 242);
        color: rgb(0, 139, 125)
    }
</style>

